export const platforms = [
    'Nintendo 64',
    'Nintendo Wii',
    'Nintendo 3ds',
    'PlayStation',
    'PlayStation 2',
    'XBox 360',
    'XBox One'
]

export default platforms